import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router';

import { AppLayoutTop } from 'components/appComponents';

import {
  useGetDriverPumpAdjustmentsInfoQuery,
  useLazyGetDriverPumpAdjustmentsInfoQuery,
} from 'bus/driverPumpAdjustments/servisec';
import { DriverPumpAdjustmentsInfoItem } from 'bus/driverPumpAdjustments/types';

import { BlockAdjustmentInfo, BlockAdjustmentTable } from './components';

const DriverPumpAdjustmentsDetail: FC = () => {
  const { id } = useParams<{ id: string }>();

  const [] = useLazyGetDriverPumpAdjustmentsInfoQuery();

  const {
    data: form = {
      comment: '',
      date: '',
      driverName: '',
      sum: 0,
    } as DriverPumpAdjustmentsInfoItem,
    refetch: getDriverPumpAdjustmentsInfo,
  } = useGetDriverPumpAdjustmentsInfoQuery({ id });

  useEffect(() => {
    getDriverPumpAdjustmentsInfo();
  }, [getDriverPumpAdjustmentsInfo]);

  return (
    <div>
      <AppLayoutTop title="Корректировка зарплат" />
      <BlockAdjustmentInfo form={form} />
      <BlockAdjustmentTable adjustmentId={id} refreshDetail={getDriverPumpAdjustmentsInfo} />
    </div>
  );
};

export default DriverPumpAdjustmentsDetail;
